import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, BoxProps } from '@modusign/design-system';

import { useGNBFoldHandle } from '@app/containers/GlobalNavigationBar/GNBFoldHandleContext';

function GNBLinkButtonIcon(props: { icon: IconProp } & BoxProps<'div'>) {
  const { folded } = useGNBFoldHandle();
  return (
    <Box p={folded ? '10px' : '3px'}>
      <Box
        as={FontAwesomeIcon}
        fontSize={folded ? '20px' : '14px'}
        height={folded ? '20px' : '14px'}
        width={folded ? '20px' : '14px'}
        {...props}
      />
    </Box>
  );
}

export default GNBLinkButtonIcon;
